export function formatPercent(percent: number): string {
  const value = Intl.NumberFormat('en', { style: 'percent', maximumFractionDigits: 0, signDisplay: 'always' }).format(
    percent,
  );

  return value.replace(',', ' ');
}
